
export function ipfsMainPeerID(peerID: string)
{
	return peerID === '12D3KooWRLthZ79SQbK8HXaDWtyg4TgpEDyYvLxAB5bDAtfuXcKY'
}
